import { axiosInstanceV2 } from "@src/shared/api";
import { IRegionsResponseDto } from "../interfaces/regionsResponseDto";
import { useAuthStore } from "@src/entities/login/model/store/authStore";
import { REQUEST_HH_API_URL } from "../constants";

export const getRegions = () => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  return axiosInstanceV2.get<IRegionsResponseDto>(
    REQUEST_HH_API_URL.getRegions(),
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    }
  );
};
